import _ from 'es-toolkit/compat';
export const isObjectWithNonNullableValues = (obj) => {
    return !Object.values(obj).some(_.isNil);
};
//# sourceMappingURL=typeguards.js.map